import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
    action,
    makeObservable,
    observable,

} from 'mobx';
import config from "../config";


class SensorListStore {
    sensorsdata = []
    senesorList = []
    assignAssetList = []
    total = 0
    loading = false
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            sensorsdata: observable,
            total: observable,
            loading: observable,
            senesorList: observable,
            assignAssetList: observable,
            loadData: action,
            getSensors: action,
            getSensorData: action,
            addData: action

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, vehicleId, pageNo, Id, isadmin, userId }) {
        this.loading = true;
        console.log("sensorlist")

        var postData = { "companyId": companyId, "vehicleId": vehicleId, "offset": offset, "limit": limit, "page": pageNo, Id: Id, isadmin: isadmin, userId: userId }

        const response = await postApi
            .getClient("")
            // .get("http://localhost:3002" + "/vehicle/getSensorData", {
            .get(config.NodeUrl + "/vehicle/getSensorData", {
                params: postData,
            });



        this.sensorsdata = response?.data?.sensordata

        this.total = parseInt(response?.data?.TotalCount);
        this.loading = false;
    }
    async getSensorData({ offset, limit, companyId, Id, isadmin, userId }) {
        this.loading = true;
        console.log("sensordata")

        var postData = { "companyId": companyId, "offset": offset, "limit": limit, Id: Id, isadmin: isadmin, userId: userId }

        const response = await postApi
            .getClient("")
            // .get("http://localhost:3002" + "/vehicle/getSensorData", {
            .get(config.NodeUrl + "/vehicle/getSensorData", {
                params: postData,
            });

        return response?.data?.sensordata[0]


    }
    async getSensors(vehicleId) {
        var postData = { "vehicleId": vehicleId }
        // const base64Input = await base64_encode(JSON.stringify(postData));
        // var response = await postApi.getClient().post("index.php?c=sensor&a=getSensorId", "postData=" + base64Input);
        var response = await postApi.getClient()
            .get(config.NodeUrl + "/vehicle/getSensorsId", {
                params: postData,
            });

        this.senesorList = response?.data?.data
    }
    async getSensorDatabyVehicleId(vehicleId) {
        var postData = { "vehicleId": vehicleId }
        // const base64Input = await base64_encode(JSON.stringify(postData));
        // var response = await postApi.getClient().post("index.php?c=sensor&a=getSensorId", "postData=" + base64Input);
        var response = await postApi.getClient()
            .get(config.NodeUrl + "/vehicle/getSensorsDatabyVehicleId", {
                params: postData,
            });

        // this.senesorListby = response?.data?.data
        return response?.data?.data
    }
    async addData(postdata) {
        var response = await postApi
            .getClient("")
            .post(
                config.NodeUrl + "/vehicle/updateSensor",
                postdata
            );
        return response;
    }
    async getAssignAsset(companyId) {
        var postData = companyId;
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
        console.log(response, response?.data?.data, "post");

        // let allAsset = [{ vehicleId: -1, vehicleNo: "ALL" }];
        let allAsset = [...response?.data?.data]; // [...allAsset, ...response?.data?.data];
        console.log(allAsset);

        this.assignAssetList = response?.data?.data;
        return response?.data?.data[0];
    }
    async deleteRecord({ Id, vehicleId }) {
        var response = await postApi
            .getClient("")
            .delete(config.NodeUrl + `/vehicle/deleteSensorDetails/${Id}/${vehicleId}`);
        return response;
    }
}

export default SensorListStore;
